import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch } from '../../../../../utils';
import { toast } from '../../../../../utils';
import axios from 'axios';

function getMonthYear(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: '2-digit' };
  return date.toLocaleDateString('en-GB', options);
}

const DETAIL_HEADER = [
  {
    header: 'Product',
    accessor: (row) => row?.main?.name
  }
];

const PRODUCT_DETAIL_HEADER = [
  {
    header: 'Batch No.',
    accessor: (row) => row?.batch_no
  },
  {
    header: 'Exp. Date',
    accessor: (row) => getMonthYear(row?.exp_date)
  },
  {
    header: 'Packing',
    accessor: (row) => row?.packing
  },
  {
    header: 'Current Stock',
    accessor: (row) => row?.totalQuantity
  }
];

export const PAtientWiseConsumptionDetailform = ({
  onClose,
  chargeType = 'opd_charges',
  onAdd,
  supplier,
  productDropdown,
  isEditMode,
  editData
}) => {
  const [productDetails, setProductDetails] = useState([]);
   const[cnt,setCnt] = useState([])
  const [batch,setBatch] = useState('')
  const [input,setInput] = useState('')
  const [productData,setProductData] = useState([])

console.log(editData,"EDIT DATA IS HERE...")
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        batch_no: Yup.string().required('Please Enter Batch No')
      })
    ),
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;


  const formSubmitHandler = (formValues) => {
    const isRqtyInvalid = billQty > stockwatch
    if(isRqtyInvalid){
      toast('Bill Qty Can not be more than the Stock',{variant:"warning"})
      return 
    }
    const transformedValues = {
      ...formValues,
    };
    onAdd(transformedValues);
    reset();
  };

  const billQty = watch('bill_qty');
  const mrp = watch('mrp');
  const stockwatch = watch('stock')

useEffect(()=>{
    if(billQty > stockwatch){
    toast('Bill Qty can not More than the Stock',{variant:"warning"})
    return
  }
},[billQty])


  useEffect(() => {
    const totalAmount = mrp * billQty;
    setValue('amount', totalAmount || 0);
  }, [billQty,  mrp,setValue]);


  const handleRowClick = (row) => {
    fetchStock(row?._id);
    setValue('product_name',row?.main?.name)

  };

const fetchStock = async (rowId) => {
  try {
    const response = await axios.get(`${BASE_URL}/stock-master/total?name=${rowId}`);
    if (response?.data?.success && Array.isArray(response.data.data)) {
      const stockList = response.data.data;
      const productDetailsArray = stockList.map(item => ({
        ...item.productDetails,
        location: item.location?.location || '',
        totalQuantity: item.productDetails.totalQuantity,
        exp_date: item.exp_date,
        batch_no: item.batch_no,
      }));
      setProductDetails(productDetailsArray);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setProductDetails([]);
    }
  } catch (error) {
    console.error(error);
    toast('Error in fetching data', { variant: 'error' });
    setProductDetails([]);
  }
};


  console.log(productDetails,"HELLO PRODUCT DETAILS IS HERE")

  function formatToMonthInput(dateStr) {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  }

  const handleRowClickProductDetail = (row) => {
    const isProduct = productDetails.some((product) => product.product === row.product);
    if (isProduct) {
      setValue('rate', row[chargeType] || 0);
    }
    setValue('batch_no', row?.batch_no);
    setValue('product', row?.productInfo?._id);
    setValue('exp_date', formatToMonthInput(row?.exp_date));
    setValue('rate', row?.purRate*row?.conversion);
    setValue('gst', row?.gst);
    setValue('cnt_no', row?.cnt);
    setValue('stock', row?.totalQuantity);
    setValue('mrp', row?.mrp*row?.conversion);
    setValue('unit', row?.productInfo?.main?.purchasing_unit_info?.unit_name);
    setValue('dis_percent', row?.dis_percent || 0);
    setValue('dis_amt', row?.dis_amt || 0);
    setValue('fqty', row?.free_qty);
    setValue('conversion', row?.conversion);
    setValue('packing', row?.packing);
    setValue('selected_product',row?.productInfo?.main?.name)
    setValue('selected_unit',row?.productInfo?.main?.purchasing_unit_info?.unit_name )

  };


  const billqtywatch = watch('bill_qty');
  const rqty = watch('rqty');
  const packing = watch('packing');
  const conversion = watch('conversion');
  const stock = watch('stock');

  const watchCnt = watch('cnt_no')

  useEffect(() => {
    if (watchCnt && cnt.length > 0) {
      const matchedCnt = cnt.find(item => item.cnt === watchCnt);
      if (matchedCnt) {
        setValue('bill_qty', matchedCnt.bill_qty);
      }
    }
  }, [watchCnt, cnt, setValue]);


  const handleChange =(e)=>{
     setInput(e.target.value)
  }
const getProductMasterDropdown = useCallback(async () => {
  const response = await axios.get(`${BASE_URL}/product-master/dropdown?limit=10`);
  setProductData(response.data.data);
}, []);

useEffect(() => {
  getProductMasterDropdown();
}, []);


const handleSearchProducts = async()=>{
    const lowercaseInput = input.toLowerCase();
    const response = await axios.get(`${BASE_URL}/product-master/dropdown?name=${lowercaseInput}&limit=10`)
      setProductData(response.data.data);
}

useEffect(()=>{
    handleSearchProducts();
},[input]);

const watchmrp = watch('mrp')
useEffect(()=>{
setValue('sale_price',watchmrp)
},[watchmrp])

  useEffect(() => {
    if (isEditMode && editData) {
      console.log(editData,"HELLO EDIT ")
      const formattedExpDate = editData.exp_date ? new Date(editData.exp_date).toISOString().slice(0, 7) : '';
      const rate = parseFloat(editData.mrp) || 0;
      const billQty = parseFloat(editData.bill_qty) || 0;
      const calculatedAmount = rate * billQty;
      reset({
        product_name: editData.product?.main?.name || editData?.productDetails?.productInfo?.main?.name,
        rate: rate,
        mrp:editData.mrp,
        stock:editData.stock,
        bill_qty: billQty,
        amount: isNaN(calculatedAmount) ? 0 : calculatedAmount,
        batch_no: editData.batch_no || '',
        exp_date: formattedExpDate,
        gst: editData.gst || 0,
        hsn_code: editData.hsn_code || '',
        product: editData?.productDetails?.productInfo?._id  || editData.product?._id,
        product_name: editData?.product_name,
        _id : editData?._id,
      });
    } else {
      reset();
    }
  }, [isEditMode, editData, reset]);

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2 }}>
            <Grid item xs={12}>
  <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'20rem'}>
    {/* First Table - no TextField above */}
    <Table
      containerSX={{ flex: 0.7, border: '1px solid rgba(0,0,0,0.27)' }}
      data={productDetails || []}
      columns={PRODUCT_DETAIL_HEADER}
      onRowClick={handleRowClickProductDetail}
      size="small"
    />

    {/* Second Table with TextField on top */}
    <Stack sx={{ flex: 0.3 }} spacing={1}>
      <MuiTextField
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            padding: '0',
            fontSize: '16px',
            fontWeight: '700'
          },
          '& .MuiOutlinedInput-input': {
            padding: '8px 14px'
          }
        }}
        label="Search By Product Name"
        variant="outlined"
        value={input}
        onChange={handleChange}
      />
      <Table
        containerSX={{ border: '1px solid rgba(0,0,0,0.27)' }}
        data={productData || []}
        columns={DETAIL_HEADER}
        size="large"
        onRowClick={handleRowClick}
      />
    </Stack>
  </Stack>
</Grid>

              <Grid item xs={12}>
                  <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.12, fontWeight: 700, fontSize: '1.4rem' }}>Product Name</Typography>
                  <TextField sx={{ flex: 1 }} name="product_name" disabled />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Batch </Typography>
                  <TextField sx={{ flex: 0.3 }} name="batch_no" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Exp. Date</Typography>
                  <TextField sx={{ flex: 0.3 }} name="exp_date" disabled type="month" />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Bill Qty</Typography>
                  <TextField sx={{ flex: 0.3 }}  name="bill_qty" type="number"/>
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Stock</Typography>
                  <TextField sx={{ flex: 0.3 }} name="stock" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                  <TextField sx={{ flex: 0.3 }} name="rate" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>MRP</Typography>
                  <TextField sx={{ flex: 0.3 }} name="mrp" disabled />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.109, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                  <TextField sx={{ flex: 0.21 }} disabled name="amount" />
                </Stack>
              </Grid>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                 {isEditMode ? "Update" : "Add"} 
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
